var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.options.status,
          expression: "options.status"
        }
      ],
      ref: "colorbar",
      staticClass: "colorbar",
      class: { "colorbar-en": this.language === "en" },
      attrs: { id: _vm.ID }
    },
    [
      _c("div", { staticClass: "colorbar-header" }, [
        _vm.help_msg
          ? _c(
              "div",
              {
                staticClass: "colorbar-help-btn",
                class: { active: _vm.is_show_help_msg },
                on: {
                  mouseover: function($event) {
                    _vm.is_show_help_msg = true
                  },
                  mouseout: function($event) {
                    _vm.is_show_help_msg = false
                  }
                }
              },
              [
                _vm._v("\n            ?\n            "),
                _c("div", { staticClass: "colorbar-help-msg" }, [
                  _vm._v(_vm._s(_vm.help_msg))
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "colorbar-title" }, [
          _vm._v(_vm._s(_vm.title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "colorbar-unit" }, [_vm._v(_vm._s(_vm.unit))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "colorbar-content" }, [
        _c("div", { staticClass: "colorbar-cursor" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "colorbar-color-item" },
          _vm._l(_vm.color_list, function(color, lv) {
            return _c("div", {
              key: lv,
              staticClass: "colorbar-color",
              class: {
                active: _vm.color_status[lv],
                "cursor-color": _vm.cursor_lv === lv
              },
              style: "background-color:" + color,
              on: {
                click: function($event) {
                  return _vm.toggle_color(lv)
                }
              }
            })
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "colorbar-value-item",
            class: ["colorbar-value-item-" + _vm.val_align]
          },
          _vm._l(_vm.val_list, function(val, lv) {
            return _c("div", { key: lv, staticClass: "colorbar-value" }, [
              _c("span", [_vm._v(_vm._s(val))])
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "colorbar-footer" },
        _vm._l(_vm.cursor_list, function(item, key) {
          return _c("div", { key: key, staticClass: "colorbar-cursor-item" }, [
            _c("span", { staticClass: "colorbar-cursor-title" }, [
              _vm._v(_vm._s(item.title))
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "colorbar-cursor-value",
                style: "width:" + _vm.cursor_val_width + "em;"
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.cursor_val[key] ? _vm.cursor_val[key] : "--")
                )
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "colorbar-cursor-unit" }, [
              _vm._v(_vm._s(item.unit))
            ])
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }